<template>
    <section>
        <b-modal v-model="open" :title="$t('message.dashboard_share')" ref="modal" id="modal-share">
            <p v-html = "$t('message.sharing_explanation', {object: itemName})"></p>
            <form @submit="submit" class="flex flex-wrap items-center gap-2">
                <input :class="{'border-red-500': emailError}" type="email" v-model="email" class="form-control" :placeholder="$t('message.email_invite_placeholder')">
                <button class="btn btn-primary" :disabled="sharing || loading"><i v-if="sharing" class="fa fa-spin fa-spinner"></i> {{$t('message.invite')}}</button>
            </form>
            <br>
            <div v-if="loading" class="flex min-h-24 items-center justify-center text-muted">
                <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                <span class="ml-2">{{$t('message.loading')}}</span>
            </div>
            <template v-else>
                <p v-if="items.length>0" v-html = "$t('message.sharing_people', {object: itemName})"></p>
                <table v-if="items.length>0" class="table share-table">
                    <tbody>
                    <tr v-for="item in items" :key="item.id">
                        <td class="share-email">{{item.email}}</td>
                        <td class="share-status">
                            <span v-if="item.registered"><i class="fa fa-check green"></i> {{$t('message.registered')}}</span>
                            <span v-else class="text-muted">{{$t('message.unregistered')}}</span>
                        </td>
                        <td class="share-resend">
                            <button v-if="!item.registered" type="button" class="text-link hover:underline disabled:cursor-not-allowed disabled:opacity-50" :disabled="item.resending" @click="resend(item)">
                                <i v-if="item.resending" class="fa fa-spin fa-spinner"></i>
                                {{$t('message.resend_invitation')}}
                            </button>
                        </td>
                        <td class="share-remove">
                        <button type="button" :disabled="item.revoking" @click="revoke(item)" class="btn btn-default">
                            <i :class="{'fa fa-spin fa-spinner': item.revoking, 'fa fa-trash': !item.revoking}"></i>
                        </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </template>
            <template #footer>
                <b-btn @click="open=false" type="primary">{{$t('message.ok')}}</b-btn>
            </template>
        </b-modal>
    </section>
</template>

<script>
    import {SHARE_REQUEST} from '../../../_store'
    import mixins from '../../../modules/mixins'

    export default {
        name: 'Share',
        mixins: [mixins],
        data () {
            return {
                open: false,
                item: false,
                emailError: false,
                email: '',
                itemName: '',
                items: [],
                loading: false,
                sharing: false,
                deleting: false
            }
        },
        methods: {
            show (item) {
                const request = {
                    entity: item.id,
                    type: item.type,
                    organization: this.activeOrganization.id,
                    action: 'read'
                }
                this.loading = true
                this.items = []
                this.$store.dispatch(SHARE_REQUEST, request)
                    .then(resp => {
                        this.items = resp.data.items.map(x => {
                            x.revoking = false
                            x.resending = false
                            return x
                        })
                    })
                    .catch(err => {
                        this.notify('danger', this.getErrorMessage(err))
                    })
                    .finally(() => {
                        this.loading = false
                    })
                this.item = item
                this.itemName = item.name
                this.open = true
            },
            revoke (share) {
                const index = this.items.indexOf(share)
                if (index === -1) {
                    return false
                }
                share.revoking = true
                this.$store.dispatch(SHARE_REQUEST, {action: 'destroy', id: share.id})
                    .then(resp => {
                        this.notify('success', resp.data.message)
                        this.items.splice(index, 1)
                        this.item.sharing = this.items.length > 0
                    }).catch(err => {
                        this.notify('danger', this.getErrorMessage(err))
                    }).finally(() => {
                        share.revoking = false
                    })
                return true
            },
            resend (item) {
                const request = {
                    shareId: item.id,
                    action: 'resend'
                }
                item.resending = true
                this.$store.dispatch(SHARE_REQUEST, request)
                  .then(resp => {
                      this.notify('success', resp.data.message)
                  })
                  .catch(err => {
                      this.notify('danger', this.getErrorMessage(err))
                  })
                  .finally(() => {
                      item.resending = false
                  })
            },
            submit (e) {
                e.preventDefault()
                this.emailError = !this.validEmail(this.email)
                if (this.emailError) {
                    return
                }
                const request = {
                    entity: this.item.id,
                    type: this.item.type,
                    email: this.email,
                    action: 'create'
                }
                this.sharing = true
                return this.$store.dispatch(SHARE_REQUEST, request)
                    .then(resp => {
                        this.item.sharing = true
                        this.notify('success', resp.data.message)
                        const item = resp.data.item
                        item.revoking = false
                        item.resending = false
                        this.items.push(item)
                        this.email = ''
                    })
                    .catch(err => {
                        this.notify('danger', this.getErrorMessage(err))
                    })
                    .finally(() => {
                        this.sharing = false
                    })
            }
        }
    }
</script>

<style scoped>
  .green {
    color: green;
  }
  .share-table {
    table-layout: fixed;
  }
  .share-email {
    width: 38%;
    overflow-wrap: anywhere;
  }
  .share-status {
    width: 24%;
  }
  .share-resend {
    width: 28%;
  }
  .share-remove {
    width: 52px;
    padding-right: 0;
    white-space: nowrap;
    text-align: right;
  }
</style>
